import { render, staticRenderFns } from "./DebugPermissions.vue?vue&type=template&id=6a3294ec&scoped=true&"
import script from "./DebugPermissions.vue?vue&type=script&lang=js&"
export * from "./DebugPermissions.vue?vue&type=script&lang=js&"
import style0 from "./DebugPermissions.vue?vue&type=style&index=0&id=6a3294ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3294ec",
  null
  
)

export default component.exports